import { IsString } from "class-validator";

export class UpdateEmailTemplatePayload {
    @IsString()
    subject: string;

    @IsString()
    content: string;
}